import { Route, Routes } from '@angular/router';
import { LoginShellComponent } from './login-shell.component';

/**
 * Provides helper methods to create routes.
 */
export class LoginShell {
  /**
   * Creates routes using the shell component and authentication.
   *
   * @param routes The routes to add.
   * @return The new route using shell as the base.
   */
  static childRoutes(routes: Routes): Route {
    return {
      path:             'login',
      component:        LoginShellComponent,
      children:         routes,
    };
  }
  static elekKommRoute(routes: Routes): Route {
    return {
      path:             'electronic-communication',
      component:        LoginShellComponent,
      children:         routes,
    };
  }
}
